import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive'
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import imgVision1 from '../img/V1.png';
import imgVision2 from '../img/V2.png';
import imgVision3 from '../img/V3.png';
import imgVision4 from '../img/V4.png';
import imgVision5 from '../img/V5.png';
import Text from '../../../common/Text.js';
import '../css/Vision.css'

function Vision() {
    const [Display, setDisplay] = useState('none');
    const [remainingHeight, setRemainingHeight] = useState(0);
    const handleHover = (height) => {
        setRemainingHeight(height);
        console.log('Received Remaining height:', height);
        setDisplay('block');
        console.log('Received Remaining height:', Display);

    };
    const handleHoverEnd = () => {
        console.log('Hover ended in MainComponent');
        setDisplay('none');
    };
    const isLaptop = useMediaQuery({ minWidth: 1024 });
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    const isMobile = useMediaQuery({ minWidth: 480, maxWidth: 767 });
    const isMobileS = useMediaQuery({ maxWidth: 479 });


    useEffect(() => {
        console.log('Vision')

        // 옵션 객체
        const options = {
            // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
            root: null,
            // 타겟 요소의 50%가 루트 요소와 겹치면 콜백을 실행
            threshold: 0.5

        };

        // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                var tt = entry.target.children;
                // console.log('하위 갯수' + entry.target.children[0].target.classList.add('te'))
                if (entry.isIntersecting) {
                    entry.target.classList.add('VisionContent_active');
                    entry.target.classList.remove('VisionContent');
                    console.log('Add active')

                    // 지연 로딩이 실행되면 unobserve 해준다.
                    // observer.unobserve(entry.target)
                }
                else {
                    // entry.target.classList.add('VisionContent');
                    // entry.target.classList.remove('VisionContent_active');
                    console.log('벗어남')
                }
            })
        }, options)


        const ims = document.querySelectorAll(".VisionContent")

        ims.forEach(img =>
            observer.observe(img)
        );


    }, []);






    return (
        <div>

            <div className='VisionMain'>
                <div className='VisionBody'>
                    <Text variant='titlename' className='VisionHello'>경영 비전</Text>
                    <div className='VisionLine'></div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className='VisionBody2'>
                        <Text variant='px32w700B' className='VisionText1'>경영이념</Text>
                        <div className="VisionContent1">
                            <div className='VisionContent2'>
                                <Text variant='px28w400'>바다를 담을 수 있는 &nbsp;</Text>
                                <Text variant='px28w600'>커다란 그릇, &nbsp;</Text>
                            </div>
                            <div className='VisionContent2'>
                                <Text variant='px28w400'>쟁반(錚盤)처럼 &nbsp;</Text>
                                <Text variant='px28w600'>끊임없이 성장하고 도전</Text>
                                <Text variant='px28w400'>해 고객을 감동시키겠습니다.</Text>
                            </div>
                            <div className='VisionContent4'>
                                <Text variant='px18w400LR'>* 쟁반(錚盤) 운두가 얕고 동글거나 네모난, 넓고 큰 그릇</Text>

                            </div>

                            {/* <p style={{fontFamily:'Pretendard', fontSize:'18px', fontWeight:'400',color:'#0C4DA2',lineHeight:'33px',margin:'0px'}}>
                                * 쟁반(錚盤) 운두가 얕고 동글거나 네모난, 넓고 큰 그릇</p> */}
                        </div>
                    </div>


                    <div className='VisionBody2'>
                        <Text variant='px32w700B' className='VisionText1'>핵심가치</Text>
                        {/* <div className="VisionContent3">
                            <div className='VisionCircle' >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '34px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <img src={imgVision1} />
                                    </div>
                                    <div className='CircleText1'>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>S</p>
                                        <p style={{ margin: '0px', fontWeight: '200' }}>olution</p>
                                    </div>
                                    <div className='CircleText2'>
                                        <p style={{ margin: '0px', fontWeight: '400' }}>어떤 새로운 문제도</p>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>능동적으로 해결</p>
                                    </div>
                                </div>
                            </div>
                            <div className='VisionCircle' >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '34px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <img src={imgVision2} />
                                    </div>
                                    <div className='CircleText1'>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>O</p>
                                        <p style={{ margin: '0px', fontWeight: '200' }}>utstanding</p>
                                    </div>
                                    <div className='CircleText2'>
                                        <p style={{ margin: '0px', fontWeight: '400' }}>고객의 니즈를 충족하는</p>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>우수한 품질</p>
                                    </div>
                                </div>
                            </div>
                            <div className='VisionCircle' >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '34px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <img src={imgVision3} />
                                    </div>
                                    <div className='CircleText1'>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>T</p>
                                        <p style={{ margin: '0px', fontWeight: '200' }}>rust</p>
                                    </div>
                                    <div className='CircleText2'>
                                        <p style={{ margin: '0px', fontWeight: '400' }}>최고의 품질과 기술로 </p>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>신뢰 추구</p>
                                    </div>
                                </div>
                            </div>
                            <div className='VisionCircle' >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '34px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <img src={imgVision4} />
                                    </div>
                                    <div className='CircleText1'>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>E</p>
                                        <p style={{ margin: '0px', fontWeight: '200' }}>xpertise</p>
                                    </div>
                                    <div className='CircleText2'>
                                        <p style={{ margin: '0px', fontWeight: '400' }}>지속적인 학습으로 </p>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>전문성 강화</p>
                                    </div>
                                </div>
                            </div>
                            <div className='VisionCircle' >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '34px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <img src={imgVision5} />
                                    </div>
                                    <div className='CircleText1'>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>C</p>
                                        <p style={{ margin: '0px', fontWeight: '200' }}>hallenge</p>
                                    </div>
                                    <div className='CircleText2'>
                                        <p style={{ margin: '0px', fontWeight: '400' }}>성장과 성취를 위한 </p>
                                        <p style={{ margin: '0px', fontWeight: '700' }}>끊임없는 도전</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}


                        {/* 경영비전 */}
                        <div className='VisionBody2'>

                            <div class="VisionBody_TWO">
                                <div class="VisionContent">
                                    <p class="VisionContent_Title">S</p>
                                    <div class="VisionContent_Bar"></div>
                                    <div class="VisionContent_TextContainer">
                                        <span class="VisionContent_Subject"><span class="VisionContent_Subject_Bold">S</span>olution</span>
                                        <div class="VisionContent_ExplContainer">
                                            <p class="VisionContent_Expl">어떤 새로운 문제도</p>
                                            <p class="VisionContent_Expl_Bold">능동적으로 해결</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="VisionContent">
                                    <p class="VisionContent_Title">O</p>
                                    <div class="VisionContent_Bar"></div>
                                    <div class="VisionContent_TextContainer">
                                        <span class="VisionContent_Subject"><span class="VisionContent_Subject_Bold">O</span>utstanding</span>
                                        <div class="VisionContent_ExplContainer">
                                            <p class="VisionContent_Expl">고객의 니즈를 충족하는</p>
                                            <p class="VisionContent_Expl_Bold">우수한 품질</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="VisionContent">
                                    <p class="VisionContent_Title">T</p>
                                    <div class="VisionContent_Bar"></div>
                                    <div class="VisionContent_TextContainer">
                                        <span class="VisionContent_Subject"><span class="VisionContent_Subject_Bold">T</span>rust</span>
                                        <div class="VisionContent_ExplContainer">
                                            <p class="VisionContent_Expl">최고의 품질과 기술로</p>
                                            <p class="VisionContent_Expl_Bold">신뢰 추구</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="VisionContent">
                                    <p class="VisionContent_Title">E</p>
                                    <div class="VisionContent_Bar"></div>
                                    <div class="VisionContent_TextContainer">
                                        <span class="VisionContent_Subject"><span class="VisionContent_Subject_Bold">E</span>xpertise</span>
                                        <div class="VisionContent_ExplContainer">
                                            <p class="VisionContent_Expl">지속적인 학습으로</p>
                                            <p class="VisionContent_Expl_Bold">전문성 강화</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="VisionContent">
                                    <p class="VisionContent_Title">C</p>
                                    <div class="VisionContent_Bar"></div>
                                    <div class="VisionContent_TextContainer">
                                        <span class="VisionContent_Subject"><span class="VisionContent_Subject_Bold">C</span>hallenge</span>
                                        <div class="VisionContent_ExplContainer">
                                            <p class="VisionContent_Expl">성장과 성취를 위한</p>
                                            <p class="VisionContent_Expl_Bold">끊임없는 도전</p>
                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>

                    </div>


                </div>
            </div>

        </div>
    );
}

export default Vision;